import { PhotoRecord } from "@/lib/catalog"
import { useTranslation } from "react-i18next"
import { ConfirmDialog, ConfirmDialogProps } from "@/components/Dialogs/ConfirmDialog"

interface PhotoTooLargeDialogProps extends ConfirmDialogProps {
	photoRecords: PhotoRecord[]
}

export function PhotoTooLargeDialog(props: PhotoTooLargeDialogProps) {
	const { t } = useTranslation("components")
	const embeddedComponent = (
		<div className="max-h-48 overflow-y-auto pb-2 text-start text-sm">
			<ul>
				{props.photoRecords
					.sort((a, b) => a.fileName.localeCompare(b.fileName))
					.map((record) => (
						<li key={record.id} className="text-sm text-base-400">
							{record.fileName}
						</li>
					))}
			</ul>
		</div>
	)

	return (
		<ConfirmDialog
			embeddedComponent={embeddedComponent}
			title={t("photoTooLargeDialog.title")}
			message={t("photoTooLargeDialog.message")}
			{...props}
		/>
	)
}
